<template>
    <el-dialog v-if="dialogFormVisible" v-el-drag-dialog custom-class="box-dialog" :visible.sync="dialogFormVisible" append-to-body="true" width="1100px" height="650px" :close-on-click-modal="false" :close-on-press-escape="false" title="分配学生">
       <div>
           <div>
             <el-form :inline="true" size="small" class="demo-form-inline">
                <el-form-item label="学号">
                 <el-input v-model="studentId" style="width:120px" placeholder="学号"></el-input>
                </el-form-item>
                <el-form-item label="姓名">
                 <el-input v-model="studentName" style="width:120px" placeholder="姓名"></el-input>
                </el-form-item>
                <el-form-item label="院系">
                 <el-input v-model="majorCategoryName" style="width:120px" placeholder="院系"></el-input>
                </el-form-item>
                <el-form-item label="专业">
                 <el-input v-model="majorSubcategoryName" style="width:120px" placeholder="专业"></el-input>
                </el-form-item>
                <el-form-item label="班级">
                 <el-input v-model="className" style="width:120px" placeholder="班级"></el-input>
                </el-form-item>
                <el-form-item>
                 <el-button type="" size="small" @click="handleSearch">查询</el-button>
                 <el-button type="" size="small" @click="handleReset">重置</el-button>
                </el-form-item>
             </el-form>
           </div>
          <el-table
              ref="multipleTable"
              :data="tableData"
              border
              size="small"
              tooltip-effect="dark"
              style="width: 100%"
              @selection-change="handleSelectionChange"
>
              <el-table-column type="selection" width="50" align="center"></el-table-column>
              <el-table-column prop="studentId" label="学号" width="120" align="center"></el-table-column>
              <el-table-column prop="name" label="姓名" width="80" align="center"></el-table-column>
              <el-table-column label="性别" width="60" align="center">
                <template slot-scope="scope">{{ scope.row.studentGender==1?'女':'男' }}</template>
              </el-table-column>
              <el-table-column prop="majorCategoryName" label="院系" align="center"></el-table-column>
              <el-table-column prop="majorSubcategoryName" label="专业" align="center"></el-table-column>
              <el-table-column prop="className" label="班级" align="center"></el-table-column>
              <el-table-column prop="mobilePhone" label="手机号" align="center"></el-table-column>
            </el-table>
            <div style="display:flex;justify-content:flex-end;padding-top:10px;">
                <el-pagination
                  v-if="pageConfig.pageTotal"
                  size="small"
                  :current-page="pageConfig.pageNum"
                  :page-sizes="pageConfig.pageSizes"
                  :page-size="pageConfig.pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="pageConfig.pageTotal"
                  @size-change="pageSizeChange"
                  @current-change="pageIndexChange"
                />
            </div>
       </div>

        <div slot="footer" class="dialog-footer">
            <el-button type=" " icon="el-icon-close" @click="handleCancel">关 闭</el-button>
            <el-button type="primary" icon="el-icon-check" @click="handleSubmit">保 存</el-button>
        </div>

    </el-dialog>
</template>

<script>
export default {
    data: function() {
        return {
            loginUser: this.$store.getters.loginUser,
            dialogFormVisible: false,
            // 分页配置
            pageConfig: {
                pageNum: 1,
                pageSize: 10,
                pageSizes: [10],
                pageTotal: 0
            },
            studentId: '',
            studentName: '',
            majorCategoryName: '',
            majorSubcategoryName: '',
            className: '',
            tableData: [],
            multipleSelection: [],
            rowDetail: {}
        }
    },
    computed: {},
    watch: {},
    created: function() {
        this.$bus.$on('openDormitoryForm', (params) => {
            this.rowDetail = params.detail
            console.log('rowDetail', this.rowDetail)

            if (params) {
                this.dialogFormVisible = true
                this.getStudentList()
            }
        })
    },
    beforeDestroy: function() {
        this.$bus.$off('openDormitoryForm')
    },
    mounted: function() {

    },
    methods: {
        handleSearch() {
            this.pageConfig.pageNum = 1
            this.getStudentList()
        },
        handleReset() {
            this.pageConfig.pageNum = 1
            this.studentId = ''
            this.studentName = ''
            this.getStudentList()
        },
        handleSelectionChange(val) {
            this.multipleSelection = val
        },
        // 分页当前页码改变
        pageIndexChange(e) {
            this.pageConfig.pageNum = e
            this.getStudentList()
        },
        // 分页展示数量改变
        pageSizeChange(e) {
            const { pageNum, pageTotal } = this.pageConfig
            if (pageNum * e > pageTotal - e) return
            this.getStudentList()
        },
        //获取学生列表
        getStudentList() {
            // let _url = 'xsgl/studentCheckIn/listdata?urlsearch=studentGender:' + this.rowDetail.gender + ';studentBasicInfoId:null&searchAndOr=or&searchMap%5BstudentId%5D=' + this.studentId + '&searchMap%5Bname%5D=' + this.studentName
            let _url = 'xsgl/studentCheckIn/listdata'
            let _params = {
                pageSize: 10,
                pageNum: this.pageConfig.pageNum,
                searchAndOr: 'and',
                urlsearch: `studentGender:${this.rowDetail.gender};studentBasicInfoId:null`,
                searchMap: {
                    studentId: this.studentId,
                    name: this.studentName,
                    majorCategoryName: this.majorCategoryName,
                    majorSubcategoryName: this.majorSubcategoryName,
                    className: this.className || this.rowDetail.className,
                    majorName: this.rowDetail.majorName || ''
                }
            }
            this.$app.listdata(_url, _params).then((res) => {
                this.tableData = res.body.pageInfo.list
                this.pageConfig.pageTotal = res.body.pageInfo.total
            })
        },
        //提交表单
        handleSubmit() {
            if (this.multipleSelection.length == 0) {
                this.$alert('请选择数据！', '操作提示', { type: 'warning' })
                return
            }
            if (this.multipleSelection.length > this.rowDetail.availableBeds) {
                this.$alert('当前选择数量大于空余床位数！', '操作提示', { type: 'warning' })
                return
            }
            let _num = this.rowDetail.totalBeds - this.multipleSelection.length
            let _startNum = 1
            if (this.rowDetail.availableBeds != this.rowDetail.totalBeds) {
                _startNum = (this.rowDetail.totalBeds - this.rowDetail.availableBeds) + 1
            }
            let _list = []
            this.multipleSelection.forEach((v, index) => {
                let obj = {
                    ...v,
                    bedNum: _startNum + index,
                    dormitoryCode: this.rowDetail.dormitoryCode,
                    dormitoryName: this.rowDetail.dormitoryName,
                    totalBeds: this.rowDetail.totalBeds,
                    schoolDormitoryId: this.rowDetail.id,
                    utbSchoolDormitoryIdserId: this.rowDetail.id,
                    studentBasicInfoId: v.tbStudentBasicInfoId
                }
                _list.push(obj)
            })
            this.$confirm('是否确认分配宿舍?', '确认操作', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http({
                    method: 'post',
                    url: '/xsgl/studentCheckIn/insertBatch',
                    data: _list
                }).then(res => {
                    if (res.code === 'success') {
                        this.refreshBedsNum()
                    } else {
                        this.$message.error(res.message)
                        this.dialogFormVisible = false
                    }
                })
            }).catch(() => {
            })
        },
        handleCancel() {
            this.pageConfig.pageNum = 1
            this.studentId = ''
            this.studentName = ''
            this.multipleSelection = []
            this.dialogFormVisible = false
        },
        //更新空床位数
        refreshBedsNum() {
            //let _data = {...this.rowDetail};
            this.rowDetail.availableBeds = this.rowDetail.availableBeds - this.multipleSelection.length
            this.$http({
                method: 'put',
                url: '/xsgl/schoolDormitory/update',
                data: this.rowDetail
            }).then(res => {
                if (res.code === 'success') {
                    this.$message.success(res.message)
                    this.$bus.emit('refreshListData')
                } else {
                    this.$message.error(res.message)
                }
                this.dialogFormVisible = false
            })
        }
    }
}
</script>
